<template>
    <div class="add-product-dialog">
        <el-dialog
            title="选择产品配置"
            :visible.sync="dialogVisible"
            custom-class="choose-config-dialog-class" 
            width="600px"
            :close-on-click-modal="false"
            @close="close"
        >
            <div class="config-choose-box">
                <el-form size="mini">
                    <el-form-item label="产品配置:" >
                        <el-cascader class="config-cascader" @change="changeConfig"
                            :options="options"
                            :props="props"
                            v-model="configData.selectedArr"
                            clearable>
                        </el-cascader>                      
                    </el-form-item> 
                    <div class="selected-config">
                        <div class="config-title">已选择的配置</div>
                        <div class="selected">
                            <el-tag class="config-item" type="info" size="mini" v-for="(item,index) in configData.selectedConfig" :key = "index">{{ item.product_name }}-{{ item.label }}</el-tag>
                        </div>
                    </div>
                </el-form>   
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="close">取 消</el-button>
                <el-button class="dialog-btn" type="primary" size="mini" @click="suerConfig" :disabled="loading || configData.selectedArr.length== 0">确认选择（{{ configData.selectedConfig.length }}）</el-button>
            </div>    
        </el-dialog>
    </div>
</template>
<script>
    export default{
        name: 'ChooseConfigDialog',
        props:{
            dialogVisible:{
                type: Boolean,
                default: false,
            },
            loading:{
                type: Boolean,
                default: false,
            },
            traderId:{
                type: Number || String,
                default: '',
            },
            // chooseConfig:{
            //     type: Array,
            //     default: function () {
            //         return []
            //     }
            // }
        },
        data(){
            return{
                props: { multiple: true },
                options: [],
                configData:{
                    selectedArr:[],
                    selectedConfig:[],
                }
            }
        },
        mounted(){
            // this.options = this.optionsData
            this.memberProductConfig()
            // console.log('options',this.optionsData)
            
        },
        methods:{
            close(){
                this.$emit('close')
            },
            // 获取选项数据
            memberProductConfig(){
                let data = {
                    traderId:this.traderId
                }
                this.$api.memberProductConfig(data).then(res=>{
                    if(res.status == 1){
                        res.data.options.forEach(item=>{
                            item.children.forEach(item2=>{    
                                item2.disabled = item2.configured == 1?true:false;
                                //检查已添加的商品配置项 设置未不可选
                                // for(let i=0;i<this.chooseConfig.length;i++){
                                //     if(item2.configured == 1  || (item.value + item2.value )== this.chooseConfig[i].product_code+this.chooseConfig[i].value){
                                //         item2.disabled = true;
                                //     }
                                // }                            
                                return item2
                            })
                            return item
                        })
                       

                        this.options = res.data.options
                    }
                })
            },
            changeConfig(val){ 
                this.configData.selectedConfig=[]
                this.configData.selectedArr = val
                for(let i = 0; i < this.configData.selectedArr.length; i++){
                    let selectItem = this.configData.selectedArr[i]
                    let selectedConfig={}
                    for(let j = 0; j < this.options.length; j++){
                        if(this.options[j].value == selectItem[0]){
                            selectedConfig.product_code= this.options[j].value;
                            selectedConfig.product_name= this.options[j].label;                    
                            if(selectItem.length == 2){
                                for(let k = 0; k < this.options[j].children.length; k++){
                                    if(this.options[j].children[k].value == selectItem[1]){
                                        selectedConfig.label= this.options[j].children[k].label;
                                        selectedConfig.value= this.options[j].children[k].value;
                                        selectedConfig.enabled= this.options[j].children[k].enabled;
                                        selectedConfig.discount = this.options[j].children[k].discount;
                                        selectedConfig.configured = this.options[j].children[k].configured;
                                        selectedConfig.disabled = this.options[j].children[k].disabled;
                                        selectedConfig.enabled_boolean= this.options[j].children[k].enabled == 1?true:false;
                                        break;
                                    }
                                }
                            }                            
                        }
                    }                    
                    this.configData.selectedConfig.push(selectedConfig)
                }
            },
            suerConfig(){
                // this.$emit('close');
                this.$emit('suerConfigChoose', this.configData.selectedConfig)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .config-cascader{
        width:460px;
    }
    .config-item{
        margin:2px 4px 2px 0px;
    }
</style>